import { UserPuzzle } from "../selectors/userPuzzleSelectors";

export default function submit(current: UserPuzzle): UserPuzzle {
  return {
    ...current,
    submitted: true,
  };
}
